import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import TvIcon from "@mui/icons-material/Tv";
import React from "react";
import { sizes } from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import { getScenarioChartData, getScenarios, setState } from "../analyzeSlice";
import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";


const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
	const [validate, setValidate] = useState({
		countryValidated:false,
		scenarioValidated:false
	});
	const [alert, setAlert] = useState({
		alertSeverity:"",
		alertDisplay:false,
		alertMessage:""
	})
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const loginState = useSelector((store) => store.login);
	const {
		countries,
		selectedCountry,
		selectedCountryID,
		scenarios,
		selectedScenarioName,
		selectedAnalysisTypeID,
		showTableData,
		showCustomerIncludedExcluded,
		selectedScenarioID
	} = state;

	const {
		globalSelectedCountryName,
		globalSelectedCountryID,
	} = loginState

	useEffect(() => {
		if (selectedCountryID !== "") {
			getScenariosForCountry();
		}
	}, [selectedCountryID]);


	function setCountry(event) {
		dispatch(setState("showTableData",false));
		const name = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === name
		).countryID;
		if(name){
			setValidate({
				...validate, countryValidated:true
			})
		}
		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));
	}

	useEffect(() => {
		if(globalSelectedCountryID !== null){
		dispatch(setState("selectedCountryID", globalSelectedCountryID));
		}
	},[globalSelectedCountryID])

	useEffect(() => {
		if(globalSelectedCountryName !== null){
		dispatch(setState("selectedCountry", globalSelectedCountryName));
		setValidate({
			...validate, countryValidated:true
		})
		}
	},[globalSelectedCountryName])

	function getScenariosForCountry() {
		const countryID = selectedCountryID;
		const activeScenario = false;
		const analyisID = selectedAnalysisTypeID;
		const obj = {
			countryID,
			activeScenario,
			analyisID,
		};
		dispatch(getScenarios(obj));
	}

	function setScenario(event) {
		dispatch(setState("showTableData",false));
		const name = event.target.value;
		//console.log("The selected scenario is",event.target.value);
		// const id = scenarios.find(
		// 	(scenario) => scenario.scenarioName === name
		// ).scenarioID;
		const selectedScenario=scenarios.find((scenario)=>scenario.scenarioID===event.target.value);
		//console.log("The selected scenario is",selectedScenario);
		if(selectedScenario){
			setValidate({
				...validate, scenarioValidated:true
			})
		}
		dispatch(setState("selectedScenarioName", selectedScenario.scenarioName));
		dispatch(setState("selectedScenarioID", selectedScenario.scenarioID));
	}

	useEffect(() => {
		//Check if any of the dropdown are false and then set alertDisplay to false
		const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

		if(isAnyKeyValueFalse(validate)){
			setAlert({...Alert, alertDisplay:false});
		}
	},[validate])

	const displayAlert = (severityType) => {
		setAlert({
			"alertSeverity": "warning",
			"alertDisplay": true,
			"alertMessage": `Please select the ${severityType}`});
	}

	useEffect(() => {
		dispatch(setState("selectedScenarioName",""));
	},[])

	function handleDisplay() {
		const obj = {
			scenarioId: selectedScenarioID,
			countryID: selectedCountryID,
		};

		//Alert if any of the dropdowns are not validated

		if(!validate.countryValidated){
			displayAlert("Country")
		}
		else if(!validate.scenarioValidated){
			displayAlert("Scenario")
		}
		else{
			dispatch(getScenarioChartData(obj));
			dispatch(setState("showTableData",true));
			dispatch(setState("showCustomerIncludedExcluded",false));
		}	
	}

	return (
		<Box sx={{ mt: 3 }}>
			<Grid container spacing={2} columns={12} justifyContent="flex-start">
				<Grid item>
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							label="Country"
							style={{width:"280px"}}
							sx={{
								height: selectHeight,
								//width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item>
					<FormControl>
						<InputLabel>Scenario</InputLabel>
						<Select
							value={selectedScenarioID}
							label="Scenario"
							style={{width:"280px"}}
							sx={{
								height: selectHeight,
								//width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setScenario}
						>
							{scenarios.map((scenario, index) => {
								return (
									<MenuItem key={index} value={scenario.scenarioID}>
										{scenario.scenarioName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item>
					<Button
					startIcon={<TvIcon />}
						sx={{
						mt:0.5,
						bgcolor: "darkred.light",
						color: "white.main",
						textTransform: "none",
						fontWeight: "bold",
						"&:hover": {
							bgcolor: "darkred.main",
							color: "white.main",
						},
               			 }}  
						onClick={handleDisplay}
					>
						Display
					</Button>
				</Grid>
			</Grid>
			{alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}
		</Box>
	);
}
